import React, {memo, useState} from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';

const AnimatedCharacter = ({
    width,
    height,
    idleData,
    animatedData,
    background,
    className,
    hitSlop,
}) => {
    const [current, setCurrent] = useState(-1);
    const [animating, setAnimating] = useState(false);

    let animationIdle = (
        <Lottie
            isClickToPauseDisabled
            options={{
                loop: true,
                autoplay: true,
                animationData: idleData,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                },
            }}
            height={height}
            width={width}
        />
    );

    const animationCompleted = () => {
        setAnimating(false);
    };

    let animatedLottie = animatedData.map(data => {
        const defaultOptions = {
            loop: false,
            autoplay: true,
            animationData: data,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
            },
        };

        return (
            <Lottie
                isClickToPauseDisabled
                options={defaultOptions}
                height={height}
                width={width}
                eventListeners={[
                    {
                        eventName: 'complete',
                        callback: animationCompleted,
                    },
                ]}
            />
        );
    });

    let backgroundLottie;
    if (background) {
        backgroundLottie = (
            <Lottie
                isClickToPauseDisabled
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: background,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice',
                    },
                }}
                height={height}
                width={width}
            />
        );
    }

    const animate = () => {
        if (!animating) {
            if (current === animatedLottie.length - 1) {
                setCurrent(0);
            } else {
                setCurrent(current + 1);
            }
            setAnimating(true);
        }
    };

    return (
        <Container className={className}>
            <BGContainer>{backgroundLottie}</BGContainer>
            {!animating && animationIdle}
            {animating && animatedLottie[current]}
            <HitArea onClick={animate} hitSlop={hitSlop} />
        </Container>
    );
};

const Container = styled.div`
    pointer-events: none;
`;

const HitArea = styled.div`
    position: absolute;
    top: ${props => props.hitSlop?.top || 0}%;
    left: ${props => props.hitSlop?.left || 0}%;
    right: ${props => props.hitSlop?.right || 0}%;
    bottom: ${props => props.hitSlop?.bottom || 0}%;
    pointer-events: auto;
    cursor: pointer;
`;

const BGContainer = styled.span`
    position: absolute;
    width: 100%;
    height: 100%;
`;

export default memo(AnimatedCharacter);
